module.exports = __webpack_public_path__ + "img/item-2-2.b5c2e0ce.png";